(() => {
  const whishListInjector = document.querySelector(
    ".hidden-wishlist-btn .wkh-button"
  );
  const wishListCounters = document.querySelectorAll(
    ".js-header-bar__show-amount-wishlist"
  );

  const populateWishlistCounter = () => {
    wishListCounters.forEach((counter) => {
      counter.innerText = parseInt(
        whishListInjector.querySelector(".wkh-counter").innerText,
        10
      );
    });
  };

  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver(() => {
    populateWishlistCounter();
  });

  observer.observe(whishListInjector, observerOptions);
  populateWishlistCounter();
})();
